import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { AuthProvider } from './context/AuthContext';
import ProtectedRoute from './components/Layout/ProtectedRoute';
import Navbar from './components/Layout/Navbar';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Installations from './pages/Installations';
import InstallationDetails from './pages/InstallationDetails';
import CreateInstallation from './pages/CreateInstallation';
import CreateBackupConfig from './pages/CreateBackupConfig';
import BackupLogs from './pages/BackupLogs';
import BackupLogDetails from './pages/BackupLogDetails';
import AllBackupLogs from './pages/AllBackupLogs';
import './App.css';

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <div className="App">
          <Navbar />
          <main className="main-content">
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route
                path="/dashboard"
                element={
                  <ProtectedRoute>
                    <Dashboard />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/installations"
                element={
                  <ProtectedRoute>
                    <Installations />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/installations/create"
                element={
                  <ProtectedRoute>
                    <CreateInstallation />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/installations/:uniqueId"
                element={
                  <ProtectedRoute>
                    <InstallationDetails />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/installations/:uniqueId/backup-config/create"
                element={
                  <ProtectedRoute>
                    <CreateBackupConfig />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/installations/:uniqueId/logs"
                element={
                  <ProtectedRoute>
                    <BackupLogs />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/backup-logs"
                element={
                  <ProtectedRoute>
                    <AllBackupLogs />
                  </ProtectedRoute>
                }
              />

              <Route
                path="/backup-config/:configId/logs"
                element={
                  <ProtectedRoute>
                    <BackupLogs />
                  </ProtectedRoute>
                }
              />
              <Route path="/" element={<Navigate to="/dashboard" replace />} />
            </Routes>
          </main>
          <ToastContainer position="top-right" autoClose={3000} />
        </div>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;